import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Core components
import Home from '../Home';
import EventComponent from '../components/Event';
import SignInwithGoogle from '../pages/Auth/signInWithGoogle';
import Profile from '../pages/Auth/Profile';
import Register from '../pages/Auth/Signup';
import Login from '../pages/Auth/Login';
import ContactUS from '../components/ContactUS';
import LandingPage from '../landing_page/LandingPage';
import About from '../components/About';
import Blog from '../components/Blog';
import PrivacyPolicy from '../components/Privacypolicy';
import TermsandConditon from '../components/T&C';
import Feedback from '../components/feedback';
import PublicProfile from '../pages/Auth/PublicProfile';
import NotificationComponent from '../components/Notification';
import TutorialCards from '../components/post';
import TutorialDetail from '../components/TutorialDetail';
import AdminPanel from '../pages/Admin/AdminPanel';
import NotFound from '../components/NotFound';
import IPUResultChecker from '../pages/IPUResult/IPUResultChecker';
import CompanyDashboard from '../pages/Company/CompanyDashboard';
import CompanyAbout from '../pages/Company/CompanyAbout';
import Opportunities from '../pages/JobPortal/Opportunities';

// Semester pages - CSE
import Sem1 from '../pages/btech/cse/Sem1';
import Sem2 from '../pages/btech/cse/Sem2';
import Sem3 from '../pages/btech/cse/Sem3';
import Sem4 from '../pages/btech/cse/Sem4';
import Sem5 from '../pages/btech/cse/Sem5';
import Sem6 from '../pages/btech/cse/Sem6';
import Sem7 from '../pages/btech/cse/Sem7';

// Semester pages - AIML
import AimlSem2 from '../pages/btech/aiml/Sem2';
import AimlSem3 from '../pages/btech/aiml/Sem3';
import AimlSem4 from '../pages/btech/aiml/Sem4';
import AimlSem5 from '../pages/btech/aiml/Sem5';

// Semester pages - AIDS
import AidsSem2 from '../pages/btech/aids/Sem2';
import AidsSem3 from '../pages/btech/aids/Sem3';
import AidsSem4 from '../pages/btech/aids/Sem4';
import AidsSem5 from '../pages/btech/aids/Sem5';

// Semester pages - IT
import ItSem1 from '../pages/btech/it/Sem1';
import ItSem2 from '../pages/btech/it/Sem2';
import ItSem3 from '../pages/btech/it/Sem3';
import ItSem4 from '../pages/btech/it/Sem4';
import ItSem5 from '../pages/btech/it/Sem5';

// Notes - CSE
import AppliedChemistry from '../pages/notes/cse/Applied Chemistry';
import AppliedMathsII from '../pages/notes/cse/Applied_Maths_II';
import AppliedPhysicsI from '../pages/notes/cse/AppliedPhysicsI';
import AppliedMathsI from '../pages/notes/cse/AppliedMathsI';
import CS from '../pages/notes/cse/Communication_Skills';
import EM from '../pages/notes/cse/Engineering_Mechanics';
import ES from '../pages/notes/cse/Electrical_Science';
import EVS from '../pages/notes/cse/Enviromental_Science';
import HVE from '../pages/notes/cse/HVE';
import IC from '../pages/notes/cse/Indian_Constitution';
import MP from '../pages/notes/cse/Manufacturing_Process';
import PC from '../pages/notes/cse/Programming_In_C';
import CM from '../pages/notes/cse/CM';
import DLCD from '../pages/notes/cse/DLCD';
import DM from '../pages/notes/cse/DM';
import DS from '../pages/notes/cse/DS';
import IKS from '../pages/notes/cse/IKS';
import OOPS from '../pages/notes/cse/OOPS';
import CD from '../pages/notes/cse/CD';
import CN from '../pages/notes/cse/CN';
import DAA from '../pages/notes/cse/DAA';
import Economics from '../pages/notes/cse/Economics';
import OS from '../pages/notes/cse/OS';
import SE from '../pages/notes/cse/SE';
import AppliedPhysicsII from '../pages/notes/cse/AppliedPhysics_II';
import Workshop from '../pages/notes/cse/Workshop';
import EG from '../pages/notes/cse/EG';
import CircuitsandSystems from '../pages/notes/cse/Circuits and Systems';
import DBMS from '../pages/notes/cse/DBMS';
import Java from '../pages/notes/cse/ProgrammingInJava';
import PSLP from '../pages/notes/cse/PSLP';
import TOC from '../pages/notes/cse/TOC';
import TW from '../pages/notes/cse/TW';
import ArtificialIntelligence from '../pages/notes/cse/AI';
import ProgrammingInPython from '../pages/notes/cse/PPY';
import PME from '../pages/notes/cse/PME';
import SSMDA from '../pages/notes/cse/SSMDA';
import UHV_II from '../pages/notes/cse/UHV-II';
import WT from '../pages/notes/cse/WT';
import PPL from '../pages/notes/cse/PPL';
import DWDM from '../pages/notes/cse/DWDM_CSE';
import RLDL from '../pages/notes/cse/RLDL';
import PRCV from '../pages/notes/cse/PRCV';
import PEM from '../pages/notes/cse/PEM';
import NGW from '../pages/notes/cse/NGW';
import ML_CSE from '../pages/notes/cse/ML_CSE';

// Notes - AIML
import AI from '../pages/notes/aiml/AI';
import FODS from '../pages/notes/aiml/Fods';
import CR from '../pages/notes/aiml/CR';
import PSLA from '../pages/notes/aiml/Psla';
import DS_AI from '../pages/notes/aiml/DS_AI';
import OOPS_AI from '../pages/notes/aiml/OOPs_aiml';
import DBMS_AI from '../pages/notes/aiml/Dbms_aiml';
import ETW from '../pages/notes/aiml/ETW';
import SE_AI from '../pages/notes/aiml/SE_aiml';
import CN_AI from '../pages/notes/aiml/CN_aiml';
import ML from '../pages/notes/aiml/ML';
import CM_AI from '../pages/notes/aiml/CM_aiml';
import UHV_AI from '../pages/notes/aiml/UHV-II';
import DataMining from '../pages/notes/aids/DataMining';
import DLD_AI from '../pages/notes/aiml/DL';
import DLCD_AI from '../pages/notes/aiml/DLCD_AI';
import COA from '../pages/notes/aiml/COA';
import DAA_AI from '../pages/notes/aiml/DAA_AI';
import PE from '../pages/notes/aiml/PE';
import OS_AI from '../pages/notes/aiml/OS_AI';
import IOT from '../pages/notes/aiml/IOT';

const PrivateRoute = ({ element, isAuthenticated }) => {
    const { loading } = useAuth();
    if (loading) return null; // Wait for auth state
    return isAuthenticated ? element : <Navigate to="/" replace />;
};

const AdminRoute = ({ element, isAdmin }) => {
    const { loading } = useAuth();
    if (loading) return null; // Wait for role state
    return isAdmin ? element : <Navigate to="/home" replace />;
};

const ProtectedRoute = ({ children, roles }) => {
    const { isAuthenticated, userRole, loading } = useAuth();

    // Never render until auth + role is fully resolved from Firestore
    if (loading) return null;

    // Wait for userRole to be finalized if we are authenticated
    if (isAuthenticated && (userRole === null)) return null;

    // userRole should never be null after loading, but guard anyway
    if (!isAuthenticated || userRole === null) {
        return <Navigate to="/login" replace />;
    }

    if (roles && !roles.includes(userRole)) {
        // Smart redirect: company users go to their dashboard, not the student home
        const fallback = userRole === 'company' ? '/job-portal/company/dashboard' : '/home';
        return <Navigate to={fallback} replace />;
    }

    return children;
};

const AppRoutes = () => {
    const { isAuthenticated, isAdmin, userRole, loading } = useAuth();

    if (loading) return null; // Global loading guard

    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={
                isAuthenticated
                    ? <Navigate to={userRole === 'company' ? '/job-portal/company/dashboard' : '/home'} />
                    : <LandingPage />
            } />
            <Route path="/job-portal" element={
                isAuthenticated
                    ? <Navigate to={userRole === 'company' ? '/job-portal/company/dashboard' : '/job-portal/opportunities'} />
                    : <LandingPage />
            } />
            <Route path="/job-portal/opportunities" element={<Opportunities />} />
            <Route path="/job-portal/company/dashboard" element={
                <ProtectedRoute roles={['company', 'admin']}>
                    <CompanyDashboard />
                </ProtectedRoute>
            } />
            <Route path="/company-about" element={
                <ProtectedRoute roles={['company', 'admin']}>
                    <CompanyAbout />
                </ProtectedRoute>
            } />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Register />} />
            <Route path="/signin" element={<SignInwithGoogle />} />
            <Route path="/notification" element={<NotificationComponent />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/terms & condition" element={<TermsandConditon />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/ipu-result" element={<IPUResultChecker />} />

            {/* Semi-Public Routes */}
            <Route path="/tech-library" element={<TutorialCards />} />
            <Route path="/tutorial/:tutorialId" element={<TutorialDetail />} />

            {/* Private Routes */}
            <Route path="/portfolio/:userId" element={<PublicProfile />} />
            <Route path="/home" element={<PrivateRoute element={<Home />} isAuthenticated={isAuthenticated} />} />
            <Route path="/event" element={<PrivateRoute element={<EventComponent />} isAuthenticated={isAuthenticated} />} />
            <Route path="/event/:id" element={<EventComponent />} />
            <Route path="/profile" element={<PrivateRoute element={<Profile />} isAuthenticated={isAuthenticated} />} />
            <Route path="/contactus" element={<ContactUS />} />
            <Route path="/blog/:postId" element={<PrivateRoute element={<Blog />} isAuthenticated={isAuthenticated} />} />
            <Route path="/blog" element={<PrivateRoute element={<Blog />} isAuthenticated={isAuthenticated} />} />

            {/* Admin Route */}
            <Route path="/admin" element={<AdminRoute element={<AdminPanel />} isAdmin={isAdmin} />} />

            {/* CSE Semester Routes */}
            <Route path="/btech/cse/1st" element={<PrivateRoute element={<Sem1 branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/cse/2nd" element={<PrivateRoute element={<Sem2 branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/cse/3rd" element={<PrivateRoute element={<Sem3 branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/cse/4th" element={<PrivateRoute element={<Sem4 branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/cse/5th" element={<PrivateRoute element={<Sem5 branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/cse/6th" element={<PrivateRoute element={<Sem6 branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/cse/7th" element={<PrivateRoute element={<Sem7 branch="CSE" />} isAuthenticated={isAuthenticated} />} />

            {/* AIML Semester Routes */}
            <Route path="/btech/aiml/1st" element={<PrivateRoute element={<Sem1 branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/aiml/2nd" element={<PrivateRoute element={<AimlSem2 branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/aiml/3rd" element={<PrivateRoute element={<AimlSem3 branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/aiml/4th" element={<PrivateRoute element={<AimlSem4 branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/aiml/5th" element={<PrivateRoute element={<AimlSem5 branch="AIML" />} isAuthenticated={isAuthenticated} />} />

            {/* AIDS Semester Routes */}
            <Route path="/btech/aids/1st" element={<PrivateRoute element={<Sem1 branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/aids/2nd" element={<PrivateRoute element={<AidsSem2 branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/aids/3rd" element={<PrivateRoute element={<AidsSem3 branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/aids/4th" element={<PrivateRoute element={<AidsSem4 branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/aids/5th" element={<PrivateRoute element={<AidsSem5 branch="AIDS" />} isAuthenticated={isAuthenticated} />} />

            {/* IT Semester Routes */}
            <Route path="/btech/it/1st" element={<PrivateRoute element={<ItSem1 branch="IT" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/it/2nd" element={<PrivateRoute element={<ItSem2 branch="IT" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/it/3rd" element={<PrivateRoute element={<ItSem3 branch="IT" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/it/4th" element={<PrivateRoute element={<ItSem4 branch="IT" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/btech/it/5th" element={<PrivateRoute element={<ItSem5 branch="IT" />} isAuthenticated={isAuthenticated} />} />

            {/* CSE/Common Notes Routes */}
            <Route path="/notes/cse/AppliedChemistry" element={<PrivateRoute element={<AppliedChemistry branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/AppliedChemistry" element={<PrivateRoute element={<AppliedChemistry />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/AppliedMathII" element={<PrivateRoute element={<AppliedMathsII branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/AppliedMathII" element={<PrivateRoute element={<AppliedMathsII />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/AppliedPhysicsI" element={<PrivateRoute element={<AppliedPhysicsI branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/AppliedPhysicsI" element={<PrivateRoute element={<AppliedPhysicsI />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/AppliedMathI" element={<PrivateRoute element={<AppliedMathsI branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/AppliedMathI" element={<PrivateRoute element={<AppliedMathsI />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/CommunicationSkills" element={<PrivateRoute element={<CS branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/CommunicationSkills" element={<PrivateRoute element={<CS />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Engineering_Mechanics" element={<PrivateRoute element={<EM branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Engineering_Mechanics" element={<PrivateRoute element={<EM />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Electrical_Science" element={<PrivateRoute element={<ES branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Electrical_Science" element={<PrivateRoute element={<ES />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Enviromental_Studies" element={<PrivateRoute element={<EVS branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Enviromental_Studies" element={<PrivateRoute element={<EVS />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Human values and Ethics" element={<PrivateRoute element={<HVE branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Human values and Ethics" element={<PrivateRoute element={<HVE />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Indian_Constitution" element={<PrivateRoute element={<IC branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Indian_Constitution" element={<PrivateRoute element={<IC />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Manufacturing_Process" element={<PrivateRoute element={<MP branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Manufacturing_Process" element={<PrivateRoute element={<MP />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Programming_In_C" element={<PrivateRoute element={<PC branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Programming_In_C" element={<PrivateRoute element={<PC />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Computational Methods" element={<PrivateRoute element={<CM branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Computational Methods" element={<PrivateRoute element={<CM />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Digital Logic and Circuit Design" element={<PrivateRoute element={<DLCD branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Digital Logic and Circuit Design" element={<PrivateRoute element={<DLCD />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Discrete Mathematics" element={<PrivateRoute element={<DM branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Discrete Mathematics" element={<PrivateRoute element={<DM />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Data Structures" element={<PrivateRoute element={<DS branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Data Structures" element={<PrivateRoute element={<DS />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Indian Knowledge System" element={<PrivateRoute element={<IKS branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Indian Knowledge System" element={<PrivateRoute element={<IKS />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Object Oriented Programming" element={<PrivateRoute element={<OOPS branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Object Oriented Programming" element={<PrivateRoute element={<OOPS />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/CD" element={<PrivateRoute element={<CD branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/CD" element={<PrivateRoute element={<CD />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/CN" element={<PrivateRoute element={<CN branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/CN" element={<PrivateRoute element={<CN />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/DAA" element={<PrivateRoute element={<DAA branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/DAA" element={<PrivateRoute element={<DAA />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Economics" element={<PrivateRoute element={<Economics branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Economics" element={<PrivateRoute element={<Economics />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/OS" element={<PrivateRoute element={<OS branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/OS" element={<PrivateRoute element={<OS />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/SE" element={<PrivateRoute element={<SE branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/SE" element={<PrivateRoute element={<SE />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/AppliedPhysicsII" element={<PrivateRoute element={<AppliedPhysicsII branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/AppliedPhysicsII" element={<PrivateRoute element={<AppliedPhysicsII />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Workshop" element={<PrivateRoute element={<Workshop branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Workshop" element={<PrivateRoute element={<Workshop />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Engineering Graphics" element={<PrivateRoute element={<EG branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Engineering Graphics" element={<PrivateRoute element={<EG />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/CircuitsandSystems" element={<PrivateRoute element={<CircuitsandSystems branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/CircuitsandSystems" element={<PrivateRoute element={<CircuitsandSystems />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/DBMS" element={<PrivateRoute element={<DBMS branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/DBMS" element={<PrivateRoute element={<DBMS />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Java" element={<PrivateRoute element={<Java branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Java" element={<PrivateRoute element={<Java />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/PSLP" element={<PrivateRoute element={<PSLP branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/PSLP" element={<PrivateRoute element={<PSLP />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Theory of Computation" element={<PrivateRoute element={<TOC branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Theory of Computation" element={<PrivateRoute element={<TOC />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Technical Writing" element={<PrivateRoute element={<TW branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/:branch/Technical Writing" element={<PrivateRoute element={<TW />} isAuthenticated={isAuthenticated} />} />

            <Route path="/notes/cse/Artificial_Intelligence" element={<PrivateRoute element={<ArtificialIntelligence branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/Programming_in_Python" element={<PrivateRoute element={<ProgrammingInPython branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/PME" element={<PrivateRoute element={<PME branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/SSDMA" element={<PrivateRoute element={<SSMDA branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/UHV-II" element={<PrivateRoute element={<UHV_II branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/WT" element={<PrivateRoute element={<WT branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/PPL" element={<PrivateRoute element={<PPL branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/DWDM" element={<PrivateRoute element={<DWDM branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/RLDL" element={<PrivateRoute element={<RLDL branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/PRCV" element={<PrivateRoute element={<PRCV branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/PEM" element={<PrivateRoute element={<PEM branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/NGW" element={<PrivateRoute element={<NGW branch="CSE" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/cse/ML_CSE" element={<PrivateRoute element={<ML_CSE branch="CSE" />} isAuthenticated={isAuthenticated} />} />

            {/* AIML/AIDS Specific Notes Routes */}
            <Route path="/notes/aiml/AI" element={<PrivateRoute element={<AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/Fods" element={<PrivateRoute element={<FODS branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/CR" element={<PrivateRoute element={<CR branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/Psla" element={<PrivateRoute element={<PSLA branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/Data Structure" element={<PrivateRoute element={<DS_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/OOPS" element={<PrivateRoute element={<OOPS_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/DBMS" element={<PrivateRoute element={<DBMS_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/ETW" element={<PrivateRoute element={<ETW branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/SE" element={<PrivateRoute element={<SE_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/CN" element={<PrivateRoute element={<CN_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/ML" element={<PrivateRoute element={<ML branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/CM" element={<PrivateRoute element={<CM_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/DLD_AI" element={<PrivateRoute element={<DLD_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/UHV-II_AI" element={<PrivateRoute element={<UHV_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/DLCD_AI" element={<PrivateRoute element={<DLCD_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/COA" element={<PrivateRoute element={<COA branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/Design Analysis and Algorithms" element={<PrivateRoute element={<DAA_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/Principles of Entrepreneurship Mindset" element={<PrivateRoute element={<PE branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/Operating Systems" element={<PrivateRoute element={<OS_AI branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/Introduction to Internet of Things" element={<PrivateRoute element={<IOT branch="AIML" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aiml/Data Mining" element={<PrivateRoute element={<DataMining branch="AIML" />} isAuthenticated={isAuthenticated} />} />

            {/* AIDS Specific */}
            <Route path="/notes/aids/AI" element={<PrivateRoute element={<AI branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/Fods" element={<PrivateRoute element={<FODS branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/CR" element={<PrivateRoute element={<CR branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/Psla" element={<PrivateRoute element={<PSLA branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/Data Structure" element={<PrivateRoute element={<DS_AI branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/OOPS" element={<PrivateRoute element={<OOPS_AI branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/DBMS" element={<PrivateRoute element={<DBMS_AI branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/ETW" element={<PrivateRoute element={<ETW branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/SE" element={<PrivateRoute element={<SE_AI branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/CN" element={<PrivateRoute element={<CN_AI branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/ML" element={<PrivateRoute element={<ML branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/CM" element={<PrivateRoute element={<CM_AI branch="AIDS" />} isAuthenticated={isAuthenticated} />} />
            <Route path="/notes/aids/Data Mining" element={<PrivateRoute element={<DataMining branch="AIDS" />} isAuthenticated={isAuthenticated} />} />

            {/* Generic Notes Fallback */}
            <Route path="/notes/:branch/:subject" element={<PrivateRoute element={<NotFound />} isAuthenticated={isAuthenticated} />} />

            {/* Catch-all 404 Route */}
            <Route path="*" element={<NotFound />} />
        </Routes >
    );
};

export default AppRoutes;
